// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-image-thumbnail[data-v-2f25b95c]{max-width:200px;height:120px;overflow:hidden;display:flex;justify-content:center;align-items:center}.c-image-thumbnail__img[data-v-2f25b95c]{width:auto;height:100%;-o-object-fit:cover;object-fit:cover}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
